import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana32Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_26488)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        d="M434.095 200.325L463.2 241.684L406.523 281.511L391.205 260.065C407.136 253.938 414.182 221.77 415.714 206.452L434.095 200.325Z"
        fill={getFillByLot(21, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M343.715 278.45C364.548 282.126 384.053 267.727 391.201 260.068L414.178 293.768L360.565 328.999L334.524 293.768L343.715 278.45Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        d="M486.17 275.386L463.193 241.687L406.517 281.513L431.025 316.745L486.17 275.386Z"
        fill={getFillByLot(20, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M386.601 367.293L360.561 328.998L414.173 293.767L438.682 328.998L386.601 367.293Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M414.176 404.054L386.604 367.291L438.685 328.996L466.257 364.227L414.176 404.054Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        d="M510.677 309.082L486.168 275.383L431.023 318.273L455.532 350.441L510.677 309.082Z"
        fill={getFillByLot(19, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        d="M535.194 341.257L510.685 309.089L455.54 350.447L481.581 384.147L535.194 341.257Z"
        fill={getFillByLot(18, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M441.754 440.819L414.182 404.056L466.263 364.229L493.835 399.461L441.754 440.819Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M561.224 371.887L535.183 341.251L481.57 384.141L509.143 417.841L561.224 371.887Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M470.849 476.05L441.745 440.819L493.826 399.46L521.399 434.691L470.849 476.05Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M588.803 404.055L561.231 371.888L509.149 417.842L535.19 450.009L588.803 404.055Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M499.956 511.283L470.852 476.052L521.401 434.693L548.973 468.393L499.956 511.283Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M614.838 434.69L588.797 404.054L533.652 450.008L562.757 482.175L614.838 434.69Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M530.594 544.982L499.958 511.282L548.976 468.392L579.612 500.559L530.594 544.982Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M642.416 465.329L614.844 434.693L562.763 482.179L591.867 514.347L642.416 465.329Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M562.762 578.68L530.595 544.981L579.612 500.559L608.716 532.726L562.762 578.68Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M669.991 494.434L642.418 465.33L591.869 514.348L620.973 543.452L669.991 494.434Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M677.647 601.659L669.988 494.433L620.971 543.45L677.647 601.659Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M593.399 610.848L562.763 578.681L610.248 532.727L640.884 563.363L593.399 610.848Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M627.107 643.016L593.407 610.848L640.893 563.362L673.061 597.062L627.107 643.016Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M665.398 679.781L627.104 643.017L673.057 597.063L677.653 600.127L686.844 672.122C681.942 686.827 670.504 683.355 665.398 679.781Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_26488"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_26488"
            transform="matrix(0.00210112 0 0 0.00278552 -3.58124 -1.45296)"
          />
        </pattern>
        <image
          id="image0_1466_26488"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
